import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';

export enum HintType {
    MOVE = 'move',
    RECYCLE = 'flipEmpty',
    MOVE_STOCKPILE = 'MOVE_STOCKPILE',
    DEAL_SPIDER = 'DEAL_SPIDER',
    RESET = 'RESET',
    PYRAMID_KING = 'PYRAMID_KING',
    PYRAMID_MOVE = 'PYRAMID_MOVE',
}
export class HintItem {
    moveGroup: Card[];
    to: GameBoardPlace;
    type: HintType;
    priority: number;
    sub: number;

    constructor(moveGroup: Card[], to: GameBoardPlace, place: HintType, priority: number, sub = 0) {
        this.moveGroup = moveGroup;
        this.to = to;
        this.type = place;
        this.priority = priority;
        this.sub = sub;
    }
}
